var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import t from '../../../../lib/translate';
import UserContainer from '../../../../reducers/authentication';
var StyledNavigation = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  align-self: center;\n  padding-left: 1em;\n  > a{\n   color: black;\n   padding: 0 1em;\n   text-decoration: unset;\n  }\n  a.active{\n    color: #447db5;\n  }\n"], ["\n  align-self: center;\n  padding-left: 1em;\n  > a{\n   color: black;\n   padding: 0 1em;\n   text-decoration: unset;\n  }\n  a.active{\n    color: #447db5;\n  }\n"])));
var Navigation = function () {
    var _a = UserContainer.useContainer(), user = _a.user, canReadTemplates = _a.canReadTemplates, canReadMessages = _a.canReadMessages;
    return (_jsxs(StyledNavigation, { children: [canReadTemplates && _jsx(NavLink, __assign({ to: "/admin/templates" }, { children: t('navigation.templates') })), canReadMessages && _jsx(NavLink, __assign({ to: "/admin/messages" }, { children: t('navigation.messages') })), (user === null || user === void 0 ? void 0 : user.isDiUser) && _jsx(NavLink, __assign({ to: "/admin/useradmin" }, { children: t('navigation.useradmin') }))] }));
};
export default Navigation;
var templateObject_1;
